import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { UploadWizardStoryComponent } from 'app/+stories/wizard/wizard.component';
import { Observable } from 'rxjs';

@Injectable()
export class CanDeactivateUploadWizardStory
  implements CanDeactivate<UploadWizardStoryComponent> {
  constructor() {}

  public canDeactivate(
    component: UploadWizardStoryComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return component.canDeactivate ? component.canDeactivate(nextState) : true;
  }
}
